import { StoreState } from 'reducers';
import { TridentCampaignDetails } from 'types/trident-campaigns';
import { RequestStates } from 'types/redux';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import i18n from 'i18n-js';
import moment from 'moment';

import formComponent from 'components/decorators/form_component';
import Toastr from 'utils/toastr-util';
import { hasJustSuccess, hasJustFail } from 'utils/request-state-utils';
import FormInputWithError from 'components/form/FormInputWithError';
import { Segment, Form, Grid, Button, Message, Icon } from 'semantic-grab-ui/src';
import { getValidatedRewardInfo } from 'actions/newTridentExtra';

interface Props {
  model: TridentCampaignDetails;
  canActivate: boolean;
  currentNode: string;
  parentKeyList: Array<string>;
  subActionIndex: number;
  getValidatedRewardRequest: RequestStates;
  onModelChange: (model?: any) => void;
  handleInputChange: Function;
  handleControlBlur: Function;
  getValidatedRewardInfo: Function;
  rewardStatus: any;
}

interface State {
  response: any;
}

interface SubAction {
  type: string;
  meta: {
    rewardID?: number;
    amount?: number;
    expireOn?: string;
    expireAfterDays?: number;
    expireAfterMinutes?: number;
    expireAfterMinutesDay?: number;
    expireAfterMinutesHour?: number;
    expireAfterMinutesMinute?: number;
    expireType?: string;
  };
  isValid?: boolean;
}

interface NodeData {
  startTime?: any;
  endTime?: any;
}

@formComponent()
export class ActionAwardRewardForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      response: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (hasJustSuccess(this.props.getValidatedRewardRequest, nextProps.getValidatedRewardRequest)) {
      const rewardID = _.get(nextProps.model.nodes[nextProps.currentNode], `data[${nextProps.subActionIndex}].meta.rewardID`);
      if (nextProps.rewardStatus.rewardID === rewardID) {
        this.setState({ response: nextProps.rewardStatus });
        const updatedModel = _.cloneDeep(nextProps.model);
        if (nextProps.rewardStatus.isValid) {
          _.set(updatedModel.nodes[nextProps.currentNode].data[nextProps.subActionIndex], 'isValid', true);
        } else {
          _.set(updatedModel.nodes[nextProps.currentNode].data[nextProps.subActionIndex], 'isValid', false);
        }
        this.props.onModelChange(updatedModel);
      }
    }
    if (hasJustFail(this.props.getValidatedRewardRequest, nextProps.getValidatedRewardRequest)) {
      Toastr.error('Failed to fetch reward\'s data');
    }
  }

  handleRewardIDChange = (event: any, data: any) => {
    const updatedModel = _.cloneDeep(this.props.model);
    _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta.rewardID', parseInt(data.value, 10));
    _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'isValid', false);
    this.props.onModelChange(updatedModel);
  };

  handleRadioSwitch = (event: any, data: any) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const rewardID = _.get(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.rewardID`, 1);
    const amount = _.get(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.amount`, 1);
    const { value } = data;
    switch (value) {
      case 'expireOn': {
        const expireDay = moment().format('YYYYMMDD');
        _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta', { rewardID, amount, expireOn: expireDay, expireAfterDays: 0, expireAfterMinutes: 0 });
        break;
      }
      case 'expireDays': {
        _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta', { rewardID, amount, expireOn: '', expireAfterDays: 1, expireAfterMinutes: 0 });
        break;
      }
      case 'expireMinutes': {
        _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta', { rewardID, amount, expireOn: '', expireAfterDays: 0, expireAfterMinutesDay: 1, expireAfterMinutesHour: 1, expireAfterMinutesMinute: 1 });
        const minutes = 1501;
        _.set(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.expireAfterMinutes`, minutes);
        break;
      }
      default: {
        break;
      }
    }
    _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta.expireType', value);
    _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'isValid', false);
    this.props.onModelChange(updatedModel);
  };

  selectExpireDayOptionDefault = () => {
    const updatedModel = _.cloneDeep(this.props.model);
    const rewardID = _.get(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.rewardID`, 1);
    const amount = _.get(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.amount`, 1);
    _.set(updatedModel.nodes[this.props.currentNode].data[this.props.subActionIndex], 'meta', { rewardID, amount, expireOn: '', expireAfterDays: 1, expireAfterMinutes: 0 });
    this.props.onModelChange(updatedModel);
  };

  calculateExpireTime = (endTime: any, subAction: SubAction): any => {
    const expireOn = subAction.meta.expireOn;
    if (expireOn) {
      return moment(expireOn, 'YYYYMMDD');
    }
    const newEndTime = endTime.clone();
    const expireAfterDays = subAction.meta.expireAfterDays;
    if (expireAfterDays > 0) {
      return newEndTime.add(expireAfterDays, 'd');
    }
    const expireAfterMinutes = subAction.meta.expireAfterMinutes;
    if (expireAfterMinutes > 0) {
      const days = subAction.meta.expireAfterMinutesDay;
      const hours = subAction.meta.expireAfterMinutesHour;
      const minutes = subAction.meta.expireAfterMinutesMinute;
      newEndTime.add({ d: days, h: hours, m: minutes });
    }
    return newEndTime;
  };

  handleRewardValidation = () => {
    const subAction: SubAction = _.get(this.props.model.nodes[this.props.currentNode], `data[${this.props.subActionIndex}]`);
    const rewardID = _.get(subAction, 'meta.rewardID');
    if (rewardID) {
      const data: any = { rewardID };
      let nodeData: NodeData = {};
      if (subAction.type === 'awardReward' || subAction.type === 'awardRewardToFamilyHost') {
        nodeData = _.get(this.props.model.nodes[this.props.parentKeyList[0]], 'data.meta', {});
        data.isBulkAward = false;
      } else if (subAction.type === 'bulkAwardReward') {
        nodeData = _.get(this.props.model.nodes[this.props.parentKeyList[0]], 'data', {});
        data.isBulkAward = true;
      }
      const startTime = nodeData.startTime;
      const endTime = nodeData.endTime;
      const expireTime = this.calculateExpireTime(endTime, subAction);
      const shouldValidateReward = startTime && endTime && expireTime;
      if (shouldValidateReward) {
        data.startAwardTime = startTime.format();
        data.endAwardTime = endTime.format();
        data.expiredTime = expireTime.clone().endOf('day').format();
        this.props.getValidatedRewardInfo(data);
      } else {
        Toastr.error('Treatment startTime and endTime should not be empty.');
      }
    }
  };

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    let expireOn = false;
    let expireDays = false;
    let expireMinutes = false;
    if (_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireOn`) > 0) {
      expireOn = true;
    }
    if (_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterDays`) > 0 && !expireOn) {
      expireDays = true;
    }
    if (_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterMinutes`) > 0 && !expireOn && !expireDays) {
      expireMinutes = true;
    }
    if (!expireOn && !expireDays && !expireMinutes) {
      this.selectExpireDayOptionDefault();
    }

    const isValidRewardID = _.get(model.nodes[currentNode], `data[${subActionIndex}].isValid`, false);
    const invalidReasons = _.get(this.state.response, 'invalidReasons', []);

    return (
      <Form>
        {!isValidRewardID &&
          <Message negative size="tiny">
            <Message.Header>
              <span className="validation-icon" />
              {!_.isEmpty(invalidReasons) ? invalidReasons.map((reason: string) => <div key={reason}>{reason}</div>)
                : 'Not valid reward id. enter valid rewardID and validate it'}
            </Message.Header>
          </Message>
        }
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.rewardID`}
                {...this.props}
              >
                {/* quickfix input value type, by using `type="number"`,
                    value will be auto converted to number.
                    But react will print warning.
                  */}
                <Form.Input
                  required
                  label={i18n.t('targets_page.fields.treatment_action_reward_id')}
                  value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.rewardID`)}
                  type="number"
                  onChange={this.handleRewardIDChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
            <Grid.Column width={4}>
              <Button
                onClick={this.handleRewardValidation}
                color="green"
                style={{ marginTop: '25px' }}
              >
                validate
              </Button>
            </Grid.Column>
            {isValidRewardID &&
              <Grid.Column>
                <Icon name="check circle outline" style={{ fontSize: '2em', marginTop: '25px', color: 'green' }} />
              </Grid.Column>
            }
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.amount`}
                {...this.props}
              >
                <Form.Input
                  label={i18n.t('targets_page.fields.reward_amount')}
                  value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.amount`)}
                  type="number"
                  min={1}
                  max={50}
                  required
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
          <Segment.Group vertical>
            <Segment>
              <Grid>
                <Grid.Column width={1}>
                  <Form.Radio
                    name="type"
                    value="expireOn"
                    checked={expireOn}
                    onChange={this.handleRadioSwitch}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data[${subActionIndex}].meta.expireOn`}
                    {...this.props}
                  >
                    <Form.Input
                      label={i18n.t('targets_page.fields.expire_on')}
                      value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireOn`)}
                      placeholder="yyyymmdd"
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                      disabled={!expireOn}
                    />
                  </FormInputWithError>
                </Grid.Column>
              </Grid>
            </Segment>
            <Segment>
              <Grid>
                <Grid.Column width={1}>
                  <Form.Radio
                    name="type"
                    value="expireDays"
                    checked={expireDays}
                    onChange={this.handleRadioSwitch}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data[${subActionIndex}].meta.expireAfterDays`}
                    {...this.props}
                  >
                    <Form.Input
                      label={i18n.t('targets_page.fields.expire_after_days')}
                      value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterDays`)}
                      type="number"
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                      disabled={!expireDays}
                    />
                  </FormInputWithError>
                </Grid.Column>
              </Grid>
            </Segment>
            <Segment>
              <Grid>
                <Grid.Column width={1}>
                  <Form.Radio
                    name="type"
                    value="expireMinutes"
                    checked={expireMinutes}
                    onChange={this.handleRadioSwitch}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data[${subActionIndex}].meta.expireAfterMinutesDay`}
                    {...this.props}
                  >
                    <Form.Input
                      label={i18n.t('targets_page.fields.expire_after_days')}
                      value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterMinutesDay`)}
                      type="number"
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                      disabled={!expireMinutes}
                    />
                  </FormInputWithError>
                </Grid.Column>
                <Grid.Column width={4}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data[${subActionIndex}].meta.expireAfterMinutesHour`}
                    {...this.props}
                  >
                    <Form.Input
                      label="hours"
                      value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterMinutesHour`)}
                      type="number"
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                      disabled={!expireMinutes}
                    />
                  </FormInputWithError>
                </Grid.Column>
                <Grid.Column width={4}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data[${subActionIndex}].meta.expireAfterMinutesMinute`}
                    {...this.props}
                  >
                    <Form.Input
                      label="minutes"
                      value={_.get(model.nodes[currentNode], `data[${subActionIndex}].meta.expireAfterMinutesMinute`)}
                      type="number"
                      onChange={this.props.handleInputChange}
                      onBlur={this.props.handleControlBlur}
                      disabled={!expireMinutes}
                    />
                  </FormInputWithError>
                </Grid.Column>
              </Grid>
            </Segment>
          </Segment.Group>
        </Grid>
      </Form>
    );
  }
}

export function mapStateToProps(state: StoreState) {
  return {
    rewardStatus: _.get(state, 'newTridents.rewardStatus', {}),
    getValidatedRewardRequest: _.get(state.requests, 'getRewradStatusRequest', {}),
  };
}

export default connect(mapStateToProps, {
  getValidatedRewardInfo,
}, null, { forwardRef: true })(ActionAwardRewardForm);

